import React from 'react'
import SideNav from './SideNav'

const KitchenDesigns = () => {
  return (
    <div>
      <>
        <div className="page-header-kitchen-designs parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Kitchen Designs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">
                      About Us
                    </a>
                    <a href="contact-us" className="btn-default btn-highlighted">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">
                  <div className="service-feature-image">
                    <figure className="image-anime reveal">
                      <img src="/imgs/kitchen-designs-mehome.jpg" alt="Kitchen Designs" />
                    </figure>
                  </div>

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      The kitchen is the centerpiece of every home — a space where creativity, family, and flavors come together. 
                      At <b>MeHome</b>, we design kitchens that blend aesthetics and efficiency to match your lifestyle. 
                      Whether you prefer a minimalist modular setup or a luxurious open-concept design, our experts bring your vision to life.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Designing <span>Smart & Stylish Kitchens</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      Our kitchen designs focus on functionality, comfort, and innovation. With an eye for detail and a passion for precision, 
                      we ensure that every inch of your kitchen serves a purpose — while looking stunning.
                    </p>

                    <ul>
                      <li>Modular and custom-designed kitchen layouts.</li>
                      <li>Durable finishes in acrylic, laminate, veneer, or PU polish.</li>
                      <li>Ergonomic designs that make movement easy and efficient.</li>
                      <li>Integrated lighting, appliances, and smart storage systems.</li>
                      <li>Eco-friendly materials and modern craftsmanship.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Specialized <span> Kitchen Solutions</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🍽️</div>
                        <div className="why-choose-item-content">
                          <h3>Modular Kitchens</h3>
                          <p>
                            Sleek, functional, and easy-to-maintain kitchens designed to maximize efficiency and 
                            complement your interior aesthetics.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">🪄</div>
                        <div className="why-choose-item-content">
                          <h3>Luxury Kitchens</h3>
                          <p>
                            Premium designs with elegant finishes, island counters, and high-end fittings for a sophisticated, timeless look.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">📐</div>
                        <div className="why-choose-item-content">
                          <h3>Compact & Smart Kitchens</h3>
                          <p>
                            Perfect for apartments — smartly designed to make the most of small spaces without compromising comfort or style.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1s">
                        <div className="icon-box">🧱</div>
                        <div className="why-choose-item-content">
                          <h3>Countertops & Cabinets</h3>
                          <p>
                            Custom-designed countertops and storage units using high-quality materials like granite, quartz, and Corian for strength and beauty.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1.2s">
                        <div className="icon-box">💡</div>
                        <div className="why-choose-item-content">
                          <h3>Lighting & Accessories</h3>
                          <p>
                            Perfectly planned lighting systems, pull-outs, and accessories that create an inspiring, clutter-free cooking environment.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                   

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why Choose <span> MeHome for Kitchen Designs</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>6+ Years of Expertise</b> in modern interior and modular designs.</li>
                        <li><b>End-to-End Service</b> — from concept planning to installation.</li>
                        <li><b>High-Quality Materials</b> for strength, durability, and style.</li>
                        <li><b>Personalized Layouts</b> tailored to your family’s needs and preferences.</li>
                        <li><b>Affordable Luxury</b> with timeless appeal and premium results.</li>
                        <li><b>On-Time Project Completion</b> with clean execution and no delays.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default KitchenDesigns
